import { useSelector } from 'react-redux';
import { SharedStoreState } from '../types';

export const navigateToSelector = (state: SharedStoreState) =>
	state.navigateTo.navigateTo;

export const useSelectNavigateTo = () => useSelector(navigateToSelector);
